import { useDispatch } from "react-redux";
import type { AppDispatch } from "../../store";
import { DispatchType } from "../../dispatcher";

export const useAppDispatch = (): DispatchType => useDispatch<AppDispatch>(); // eslint-disable-line
